import React from "react";
import Container from 'react-bootstrap/Container';
import { Link } from 'react-router-dom';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';


const About = () =>{
  
  return (
    <div className="about">
      <section className="inner-banner banner-align">
        <img className="img-fluid" src={process.env.PUBLIC_URL + "/assets/img/innerbanner/about.jpg"} alt="About Habib University Library"/>
      </section>
     
      <section  className="research-box-area">
           <Container>
              <div className='information-content'>
                <h2>About</h2>
                <p>Habib University’s Library and Information Commons serves as a central hub within the University, aligning with our institution's mission to shape futures by enriching the intellectual pursuits of students, faculty, and staff. The HU Library achieves this by providing access to diverse resources and services. As the best library in Karachi, we offer a variety of learning spaces tailored to meet the diverse learning styles of the students. These spaces include collaborative workspaces, group study rooms, independent study areas for contemplation, reflection, research, and writing, as well as a small makerspace for promoting creativity and interdisciplinary learning.  </p>
              </div>
              <Row>
                  <Col lg={4} sm={6} className="border-bottom">
                    <div className="research-box">
                      <img src={process.env.PUBLIC_URL + "/assets/img/researchtool/e-resource-icon.svg"} alt=""/>
                      <h5>Library Hours</h5>
                      <p>During the semester, the HU library hours are from Monday to Friday, 8:00 a.m. to 7:30 p.m., and 8:00 a.m. to 5:00 p.m. on working Saturdays. Library hours during the summer and winter breaks are from 9:00 a.m. to 5:00 p.m.</p>
                      <Link as={Link} to="/library-hours" className='btn-dfault'>
                        See Details
                      </Link>
                    </div>
                  </Col>
                  <Col lg={4} sm={6} className="border-end border-start border-bottom">
                    <div className="research-box">
                      <img src={process.env.PUBLIC_URL + "/assets/img/researchtool/newspaper-icon.svg"} alt=""/>
                      <h5>Patron/User Policies Borrowing Policies</h5>
                      <p>For borrowing information related to books and resources, visit the borrowing policies tab available at <Link to="/frequently-asked-questions">FAQ's</Link></p>
                      <Link as={Link} to="/borrowing-policies" className='btn-dfault'>
                        See Details
                      </Link>
                    </div>
                  </Col>
                  <Col lg={4} sm={6} className="border-bottom">
                    <div className="research-box">
                      <img src={process.env.PUBLIC_URL + "/assets/img/researchtool/free-open-access-icon.svg"} alt=""/>
                      <h5>Internship & student employment Opportunities</h5>
                      <p>For career and professional growth, the library provides Internship opportunities to Library Science fresh graduates during the Summer, and student employment opportunities for Habib University students during semester, summer and winter breaks. For more details, write to  <a href="mailto:library@habib.edu.pk">library@habib.edu.pk</a></p>
                    </div>
                  </Col>
              </Row>
           </Container>
      </section>
     
    </div>
  );
}
export default About;